import types from './actionTypes'
import { PENDING, SUCCESS, FAILURE } from 'constants/configs'

const initialState = {
  regions: {
    items: [],
    loading: true,
    error: '',
    totalPages: 0,
    moreLoading: false,
  },
}

const regionReducer = (state = initialState, { payload, type }) => {
  let index
  switch (type) {
    case PENDING(types.GET_REGIONS):
      return {
        ...state,
        regions: {
          ...state.regions,
          loading: true,
        },
      }
    case SUCCESS(types.GET_REGIONS):
      return {
        ...state,
        regions: {
          ...state.regions,
          items: payload.data,
          totalPages: payload.meta.last_page,
          loading: false,
        },
      }
    case FAILURE(types.GET_REGIONS):
      return {
        ...state,
        regions: {
          ...state.regions,
          loading: false,
          error: payload,
        },

      }
    case PENDING(types.GET_MORE_REGIONS):
      return {
        ...state,
        regions: {
          ...state.regions,
          moreLoading: true,
        },
      }
    case SUCCESS(types.GET_MORE_REGIONS):
      return {
        ...state,
        regions: {
          ...state.regions,
          items: [...state.regions.items, ...payload.data],
          moreLoading: false,
        },
      }
    case FAILURE(types.GET_MORE_REGIONS):
      return {
        ...state,
        regions: {
          ...state.regions,
          moreLoading: false,
          error: payload,
        },
      }
    case SUCCESS(types.CREATE_REGION):
      return {
        ...state,
        regions: {
          ...state.regions,
          items: [...state.regions.items, payload.data],
        },
      }
    case SUCCESS(types.EDIT_REGION):
      const newItems = state.regions.items
      index = newItems.findIndex((el) => el.uuid === payload.data.uuid)
      newItems[index] = payload.data
      return {
        ...state,
        regions: {
          ...state.regions,
          items: [...newItems],
        },
      }
    case SUCCESS(types.DELETE_REGION):
      index = state.regions.items.findIndex((el) => el.uuid === payload)
      return {
        ...state,
        regions: {
          ...state.regions,
          items: [
            ...state.regions.items.slice(0, index),
            ...state.regions.items.slice(index + 1),
          ],
        },
      }
    case SUCCESS(types.CLEAR_REGIONS):
      return {
        ...state,
        regions: {
          items: [],
          loading: true,
          error: '',
          totalPages: 0,
          moreLoading: false,
        },
      }
    default:
      return state
  }
}

export default regionReducer
